module.exports = __webpack_public_path__ + "img/632-0401b2.png";